/**
 * Kurzes Vibrieren beim Abhaken. iOS-Safari hat keine Vibrations-Funktion,
 * aber der eingebaute iOS-Schalter (<input type=checkbox switch>) löst beim
 * Umschalten einen kurzen Taptic-Impuls aus. Wir schalten einen versteckten
 * Schalter über sein Label um – das muss innerhalb eines Fingertipps passieren.
 */
let label: HTMLLabelElement | null = null;

function ensure(): HTMLLabelElement {
  if (label) return label;
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.setAttribute('switch', '');
  input.id = 'haptic-switch';
  input.className = 'haptic-switch';
  input.tabIndex = -1;
  input.setAttribute('aria-hidden', 'true');
  label = document.createElement('label');
  label.htmlFor = input.id;
  label.className = 'haptic-switch';
  label.setAttribute('aria-hidden', 'true');
  document.body.append(input, label);
  return label;
}

/** Einmal kurz vibrieren (nur direkt in einem Fingertipp-Handler aufrufen). */
export function haptic(): void {
  try {
    const nav = navigator as Navigator & { vibrate?: (ms: number) => boolean };
    if (typeof nav.vibrate === 'function') {
      nav.vibrate(12);
      return;
    }
    ensure().click();
  } catch {
    /* egal – ist nur ein Extra */
  }
}
